import { createStore } from 'redux';
import { getMiddleware } from './Middleware';
import { Reducer, InitialState } from '../reducers/ReducerWrapper';

export const _store = createStore(Reducer, InitialState, getMiddleware());
